var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "dark": "",
      "no-click-animation": "",
      "fullscreen": "",
      "overlay-color": "black",
      "overlay-opacity": "0.4",
      "content-class": "v-dialog--full"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
            on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on,
          setIndex: _vm.setIndex
        })];
      }
    }], null, true),
    model: {
      value: _vm.showsDialog,
      callback: function callback($$v) {
        _vm.showsDialog = $$v;
      },
      expression: "showsDialog"
    }
  }, [_c('div', {
    staticClass: "v-dialog--full__container"
  }, [_c('div', {
    staticClass: "gallery-imgs-modal"
  }, [_c('div', {
    staticClass: "gallery-imgs-modal__con"
  }, [_c('v-btn', {
    staticClass: "v-btn--none-active-bg",
    attrs: {
      "large": "",
      "icon": "",
      "text": "",
      "disabled": _vm.disable_prev
    },
    on: {
      "click": _vm.goPrev
    }
  }, [_c('i', {
    staticClass: "icon icon-arrow2-left"
  })]), _c('div', {
    staticClass: "gallery-imgs-modal__img"
  }, [_c('v-tabs-items', {
    attrs: {
      "value": _vm.selectedIndex
    }
  }, _vm._l(_vm.imgs, function (img, index) {
    return _c('v-tab-item', {
      key: img.url,
      attrs: {
        "value": index
      }
    }, [_vm.disableLink ? [_c('v-img', {
      attrs: {
        "src": img.url,
        "aspect-ratio": 1 / 1,
        "contain": ""
      }
    })] : _c('a', {
      attrs: {
        "href": img.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('v-img', {
      attrs: {
        "src": img.url,
        "aspect-ratio": 1 / 1,
        "contain": ""
      }
    })], 1)], 2);
  }), 1)], 1), _c('v-btn', {
    staticClass: "v-btn--none-active-bg",
    attrs: {
      "large": "",
      "icon": "",
      "text": "",
      "disabled": _vm.disable_next
    },
    on: {
      "click": _vm.goNext
    }
  }, [_c('i', {
    staticClass: "icon icon-arrow2-right"
  })])], 1), _c('div', {
    staticClass: "gallery-imgs-modal__thumb-wrap"
  }, _vm._l(_vm.imgs, function (img, index) {
    return _c('div', {
      key: img.url,
      staticClass: "gallery-imgs-modal__thumb",
      class: {
        'active': _vm.selectedIndex == index
      },
      on: {
        "mouseenter": function mouseenter($event) {
          return _vm.setIndex(img);
        }
      }
    }, [_c('v-img', {
      attrs: {
        "src": img.url,
        "aspect-ratio": 1 / 1,
        "width": "100%"
      }
    })], 1);
  }), 0)]), _c('v-fade-transition', {
    attrs: {
      "hide-on-leave": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showsCloseBtn,
      expression: "showsCloseBtn"
    }],
    staticClass: "v-dialog--full__close",
    on: {
      "click": function click($event) {
        _vm.showsDialog = false;
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-close"
  })])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }